import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadMoreProps } from 'features/common/components/Table/types';
import { PunchupSpinner } from 'features/common/components/Punchup/primitives/feedback/PunchupSpinner';
import styles from './PunchupLoadMore.module.css';

interface PunchupLoadMoreProps extends LoadMoreProps {
	/**
	 * Unobtrusive pagination indicator. While the next page is being fetched,
	 * the button label is replaced with a spinner and the button is implicitly
	 * disabled (so the user cannot stack overlapping fetches). The spinner sits
	 * inside the button rather than over the table so the table content stays
	 * stable mid-scroll.
	 */
	isLoading?: boolean;
}

export const PunchupLoadMore: FC<PunchupLoadMoreProps> = ({ isDisabled, handleClick, isLoading = false }) => {
	const { t } = useTranslation();
	return (
		<div className={styles.wrapper}>
			<button
				className={styles.button}
				onClick={handleClick}
				disabled={isDisabled || isLoading}
				aria-busy={isLoading || undefined}
				type="button"
			>
				{isLoading ? <PunchupSpinner size={16} /> : t('button-load-more')}
			</button>
		</div>
	);
};
